import { TILING_TYPE } from './unityConstants';

export const UPLOAD_MAP_FILTER_TYPE = 2;
export const UPLOAD_MAP_FILTER_ID = 39;

// export const UPLOAD_MAP_FILTER_NAME = {
//   [TILING_TYPE.GLOSSY]: 'glossiness',
//   [TILING_TYPE.AO]: 'ao',
//   [TILING_TYPE.TRANSPARENCY]: 'transparency',
//   [TILING_TYPE.DEPTH]: 'normal',
//   [TILING_TYPE.METALLIC]: 'metallic',
// }

export const UPLOAD_MAP_TO_FILTER_ID = {
  [TILING_TYPE.TEXTURE]: 1520,
  [TILING_TYPE.GLOSSY]: 1522,
  [TILING_TYPE.AO]: 1523,
  [TILING_TYPE.TRANSPARENCY]: 1525,
  [TILING_TYPE.DEPTH]: 1521,
  [TILING_TYPE.METALLIC]: 1524,
  [TILING_TYPE.DISPLACEMENT]: 10107,
  [TILING_TYPE.TUFT_DISPLACEMENT]: process.env.REACT_APP_ENV === 'production' ? 12097 : 10508,
};

export const GENERATED_NORMAL_MAP_FILTER_OPTION_ID = 1526;

export const OPEN_PROJECT_ID = 'open';

export const PRODUCT_BUILDER_LOAD_ROOM_ID_DEV = 2913;
export const PRODUCT_BUILDER_LOAD_ROOM_ID_PROD = 2640;
